<ng-container *transloco="let t">
  @if (!loadLoginPage) {
    <div class="loading-animation">
      <a (click)="submitSocial(nickname)"
        ><img class="body-loader" src="assets/xi-cx-loader.gif" />
      </a>
    </div>
  }
  @if (loadLoginPage) {
    <div class="login__container">
      <section class="login__main-content-container">
        <div class="login__login-section-container" [ngClass]="{ 'login--blur': isLoading }">
          <div class="login__logo-wrapper">
            <img class="login__logo" src="../../../../assets/lexalytics-logo.svg" />
          </div>
          <div class="login__welcome-wrapper">
            <h1 class="kxi-text-xlarge">
              <span class="normal block">{{ t('login.welcome') }}</span>
              <span class="block"
                >Spotlight
                <span class="kxi-text-medium normal">&nbsp; ({{ envName }})</span>
              </span>
            </h1>
            @if (customMessage) {
              <div class="login__custom-message">
                <mat-icon>{{ customIcon }}</mat-icon> {{ customMessage }}
              </div>
            }
          </div>
          <div class="login__form-wrapper">
            <form #loginForm="ngForm" (ngSubmit)="submit()">
              @if (showUserLogin) {
                <div class="login__input-field-wrapper">
                  <xi-input-field
                    appAutoFocus="xiInput"
                    autoComplete="username"
                    label="{{ t('login.username-label') }}"
                    name="login"
                    type="text"
                    [(ngModel)]="login"
                    [status]="loginNameStatus"
                    (onChange)="onValidateLoginName(loginForm)"
                    (onClick)="onRefreshInput()"
                    (keydown.Tab)="onRefreshInput()"
                  ></xi-input-field>
                </div>
                <div class="login__input-field-wrapper">
                  <xi-input-field
                    autoComplete="current-password"
                    label="{{ t('login.password-label') }}"
                    type="password"
                    name="password"
                    [(ngModel)]="password"
                    [status]="passwordStatus"
                    (onChange)="onValidatePassword(loginForm)"
                    (onClick)="onRefreshInput()"
                    (keydown.Tab)="onRefreshInput()"
                    (onInputEnter)="!isSignInDisabled && submit()"
                  ></xi-input-field>
                </div>
              }
              <div class="login__social-buttons">
                @for (choice of socialChoices; track choice) {
                  <div class="login__sign-in-button">
                    <xi-default-button
                      buttonSize="xxlarge"
                      [stretch]="true"
                      [disabled]="isLoading"
                      [text]="'Login via ' + choice.display"
                      type="button"
                      (onClick)="submitSocial(choice.key)"
                    ></xi-default-button>
                  </div>
                }
              </div>
              <div class="login__input-error-message">
                @if (error) {
                  <div class="kxi-text-small">
                    @switch (error) {
                      @case ('SessionExpired') {
                        <div>
                          {{ t('login.error.SessionExpiredError') }}
                        </div>
                      }
                      @case ('SessionExpiredError') {
                        <div>
                          {{ t('login.error.SessionExpiredError') }}
                        </div>
                      }
                      @case ('MissingLoginError') {
                        <div>
                          {{ t('login.error.MissingLoginError') }}
                        </div>
                      }
                      @case ('LoginDisabled') {
                        <div>{{ t('login.error.LoginDisabled') }}</div>
                      }
                      @case ('InvalidLoginError') {
                        <div>
                          {{ t('login.error.InvalidLoginError') }}
                        </div>
                      }
                      @case ('SessionLimitReachedError') {
                        <div>
                          {{ t('login.error.SessionLimitReachedError') }}
                        </div>
                      }
                      @case ('InvalidSessionError') {
                        <div>
                          {{ t('login.error.InvalidSessionError') }}
                        </div>
                      }
                      @case ('AccountExpiredError') {
                        <div>
                          {{ t('login.error.AccountExpiredError') }}
                        </div>
                      }
                      @case ('SemantriaUserCreateError') {
                        <div>
                          {{ t('login.error.SemantriaUserCreateError') }}
                        </div>
                      }
                      @case ('AccountNotProvisioned') {
                        <div>
                          {{ t('login.error.SessionExpired') }}
                        </div>
                      }
                      @default {
                        <div>{{ t('login.error.default') }}</div>
                      }
                    }
                  </div>
                }
              </div>
              @if (showUserLogin) {
                <div class="login__forgot-password-wrapper kxi-text-normal">
                  <a
                    href="mailto:support@lexalytics.com?subject=Forgotten password request&body=Please reset my password for Spotlight"
                    >{{ t('login.forgot-password') }}</a
                  >
                </div>
                <div class="login__submit-button">
                  <xi-default-button
                    [stretch]="true"
                    [disabled]="isSignInDisabled"
                    text="{{ t('login.signin-button') }}"
                    type="submit"
                  ></xi-default-button>
                </div>
              }
            </form>
            <div class="login__horizontal-divider"></div>
            <p class="kxi-text-xsmall login__app-version">Version {{ appVersion }}</p>
          </div>
          <div class="login__copyright-wrapper kxi-text-xsmall">
            <footer>
              {{ this.currentYear }} InMoment, Inc. All rights reserved. Unauthorized access is
              prohibited
            </footer>
          </div>
        </div>
        @if (isLoading) {
          <div class="xi-loader-container__inline-overlay login__loading">
            <xi-animation [loop]="true" animation="cx_loader"></xi-animation>
          </div>
        }
      </section>
      <section class="login__info-pane-container" [@flyInRight]="flyInState">
        <div class="login__info-pane-content">
          <h2 class="kxi-text-xlarge kxi-text-600">
            <div>{{ t('login.info-upper') }}</div>
          </h2>
          <p class="login__info-pane-subtitle kxi-text-medium">
            {{ t('login.info-lower') }}
          </p>
          <div class="login__info-pane-button">
            <xi-default-button
              text="{{ t('login.learnmore-button') }}"
              [stretch]="true"
              fill="outline"
              type="button"
              (onClick)="onClickLearnMore()"
            ></xi-default-button>
          </div>
        </div>
      </section>
    </div>
  }
</ng-container>
